import * as pako from 'pako';
import { saveAs } from 'file-saver';
import { ApiRequestStandardResponse } from '../../api/types';

export function createDownloadabeFileFromResponseAndSave(
  response: ApiRequestStandardResponse,
): void {
  // If url is given
  if (response && response.dataInfo && response.dataInfo.dataIsUrl) {
    // This does not always work. It is better to create an anchor with the href set to the url
    saveAs(response.data, response.dataInfo.fileName);
    return;
  }

  const base64decodedData =
    response.dataInfo?.base64Encoded !== false
      ? atob(response.data)
      : response.data;
  let unzippedData = null;
  let rawBytes = null;
  if (response.dataInfo?.compressed) {
    const inflated = JSON.parse(
      pako.inflate(base64decodedData, { to: 'string' }),
    );
    unzippedData = atob(inflated);
    rawBytes = new Uint8Array(unzippedData.length);
    for (let i = 0; i < rawBytes.length; i++) {
      rawBytes[i] = unzippedData.charCodeAt(i);
    }
  } else {
    unzippedData = base64decodedData;
    // Convert raw data to Byte array for file generation
    rawBytes = new Uint8Array(unzippedData.length);
    for (let i = 0; i < rawBytes.length; i++) {
      rawBytes[i] = unzippedData.charCodeAt(i);
    }
  }

  const blob = new Blob(
    [rawBytes],
    // [unzippedData],
    {
      type: response.dataInfo?.fileMime
        ? response.dataInfo.fileMime
        : 'text/plain',
    },
  );
  saveAs(
    blob,
    response.dataInfo?.fileName ? response.dataInfo.fileName : 'download',
  );
}
